import useAuthStore from "./useAuth";
import useShopStore from "./useShop";
import useGeneralStore from "./useGeneral";
import useRequestStore from "./useRequest";
import useSignUpStore from "./useSignUp";
import useCompanyStore from "./useCompany";
import useUserStore from "./useUser";
import useProductStore from "./useProduct";

const resetAllStores = () => {
  // Call each store's reset function
  return Promise.all([
    useAuthStore.getState().resetAuth(),
    useShopStore.getState().resetShop(),
    useGeneralStore.getState().resetGeneral(),
    useRequestStore.getState().resetRequest(),
    useSignUpStore.getState().resetSignUp(),
    useCompanyStore.getState().resetCompany(),
    useUserStore.getState().resetUser(),
    useProductStore.getState().resetProduct(),
  ]);
};

export default resetAllStores;
